import React, { Component } from "react";
import { Switch, Route, Link } from "react-router-dom";
import Button from '@material-ui/core/Button';
import "./App.css";
import "./components/componentGrid.css";
import LogoNM from './img/LogoNM.svg';

import AuthService from "./services/auth.service";

import BackgroundVideo from './components/BackgroundVideo/BackgroundVideo';
import Login from "./components/login.component";
import Register from "./components/register.component";
import Home from "./components/home.component";
import Profile from "./components/profile.component";
import BoardUser from "./components/board-user.component";
import BoardModerator from "./components/board-moderator.component";
import BoardAdmin from "./components/board-admin.component";


class App extends Component {
  constructor(props) {
    super(props);
    this.logOut = this.logOut.bind(this);

    this.state = {
      showModeratorBoard: false,
      showAdminBoard: false,
      currentUser: undefined,
    };
  }

  componentDidMount() {
    const user = AuthService.getCurrentUser();

    if (user) {
      this.setState({
        currentUser: user,
        showModeratorBoard: user.roles.includes("ROLE_MODERATOR"),
        showAdminBoard: user.roles.includes("ROLE_ADMIN"),
      });
    }
  }

  logOut() {
    AuthService.logout();
  }

  render() {
    const { currentUser, showModeratorBoard, showAdminBoard } = this.state;


    return (
      <div>
        <BackgroundVideo />
        <nav className="navbar navbar-expand navbar-dark bg-dark">
          <Link to={"/"} className="navbar-brand">
            <img className={"logo-img"} src={LogoNM} alt="profile-img" />
          </Link>
          <div className="navbar-nav mr-auto">
            <li className="nav-item">
              <Button color="inherit" href="/home">
                <div>Aqua Solar Undervannsbelysning</div>
              </Button>
            </li>

            {showModeratorBoard && (
              <li className="nav-item">
                <Button color="inherit" href="/mod">Moderator</Button>
              </li>
            )}

            {showAdminBoard && (
              <li className="nav-item">
                <Button color="inherit" href="/admin">Admin</Button>
              </li>
            )}

            {currentUser && (
              <li className="nav-item">
                <Button color="inherit" href="/user">Systemer</Button>
              </li>
            )}
          </div>

          {currentUser ? (
            <div className="navbar-nav ml-auto">
              <li className="nav-item">
                <Button color="inherit" href="/login" onClick={this.logOut}>Logg ut</Button>
              </li>
            </div>
          ) : (
            <div className="navbar-nav ml-auto">
              <li className="nav-item">
                <Button color="inherit" href="/login">Log inn</Button>
              </li>

              <li className="nav-item">
                <Button color="inherit" href="/register">Registrer</Button>
              </li>
            </div>
          )}
        </nav>

        <div className="container mt-3">
          <Switch>
            <Route exact path={["/", "/home"]} component={Home} />
            <Route exact path="/login" component={Login} />
            <Route exact path="/register" component={Register} />
            <Route exact path="/profile" component={Profile} />
            <Route path="/user" component={BoardUser} />
            <Route path="/mod" component={BoardModerator} />
            <Route path="/admin" component={BoardAdmin} />
          </Switch>
        </div>
      </div>
    );
  }
}

export default App;
